module.exports = __webpack_public_path__ + "media/img/manual-testing/wave-35500abbc0f7282cdd264c13ce6b413c.svg";